<template>
    <div class="area-content-head head-overview">
        <div class="head-toolbar-large">
            <router-link v-for="item in visibleItems"
                         :key="item.context"
                         :to="item.enabled ? ('/Admin/' + item.context) : $route.fullPath"
                         class="head-toolbar-item"
                         :class="{ 'disabled': !item.enabled }"
                         @click.prevent="!item.enabled">
                <div class="head-toolbar-item-icon material-symbols-outlined">{{ item.icon }}</div>
                <div v-if="!item.subLabel" class="head-toolbar-item-label">{{ item.label }}</div>
                <div v-if="item.subLabel" class="head-toolbar-item-label-main">{{ item.label }}</div>
                <div v-if="item.subLabel" class="head-toolbar-item-label-sub">{{ item.subLabel }}</div>
            </router-link>
        </div>
        <div class="head-placeholder"></div>
        <head-component />
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';
    import headComponent from '../components/head-component.vue';
    import meApi from '../services/MeApi';
    import AppPermissions from '../constants/AppPermissions';

    const items = [
        {
            label: "Mitarbeiter",
            subLabel: "Verwaltung",
            icon: "manage_accounts",
            context: "",
            readPermission: AppPermissions.AdminUsers.Read
        },
        {
            label: "Mandanten",
            subLabel: "Verwaltung",
            icon: "groups",
            context: "Tenants",
            readPermission: AppPermissions.AdminTenants.Read
        },
        {
            label: "Template",
            subLabel: "Verwaltung",
            icon: "contract_edit",
            context: "Templates",
            readPermission: AppPermissions.AdminTemplates.Read
        },
        {
            label: "Dropdown",
            subLabel: "Verwaltung",
            icon: "expand_circle_down",
            context: "Lists",
            readPermission: AppPermissions.AdminDropDowns.Read
        },
        {
            label: "Rollen",
            subLabel: "Verwaltung",
            icon: "theater_comedy",
            context: "Roles",
            readPermission: AppPermissions.AdminRoles.Read
        }
    ];

    export default defineComponent({
        components: {
            headComponent
        },
        data() {
            return {
                items
            };
        },
        computed: {
            visibleItems() {
                return this.items.map(item => ({
                    ...item,
                    enabled: !item.readPermission || meApi.hasPermissionSync(item.readPermission)
                }));
            }
        }
    });
</script>

<style>
    .area-content-head.head-overview {
        border: none;
    }

    .head-toolbar-item.disabled {
        opacity: 0.4;
        pointer-events: auto;
        cursor: default;
    }

        .head-toolbar-item.disabled .head-toolbar-item-icon,
        .head-toolbar-item.disabled .head-toolbar-item-label,
        .head-toolbar-item.disabled .head-toolbar-item-label-main,
        .head-toolbar-item.disabled .head-toolbar-item-label-sub {
            opacity: 0.7;
        }
</style>